export enum HairProductKey {
  hair = "hair",
  eyebrows = "eyebrows",
  beard = "beard",
  prp = "prp",
  ht = "ht",
  bundle = "bundle",
  freePrp = "freePrp",
  mesotherapy = "mesotherapy",
  freeMesotherapy = "freeMesotherapy",
}
